import { ApplicationConfig } from '@angular/core';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitanDevkitCoreModule } from '@titan/devkit/core';
import { TitanZoneSelectorModule } from '@titan/devkit/zone-selector';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './core/reducers';
import { UserModule } from '@titan/devkit/user';
import { environment } from '../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { RouterEffects } from './atlas-router/atlas-router.effects';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { AuthModule } from './auth/auth.module';
import { EventsModule } from './events/events.module';
import { AppRouterModule } from './app-router.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { APP_BASE_HREF } from '@angular/common';
export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            BrowserModule,
            BrowserAnimationsModule,
            TitanDevkitCoreModule.forRoot({
                appName: 'entry',
                title: 'Titan',
                standaloneApp: false,
            }),
            TitanZoneSelectorModule.forRoot({ enableAllZonesSelector: true, enabledSidenavCollapse: true }),
            StoreModule.forRoot(reducers, {
                metaReducers,
                runtimeChecks: { strictStateImmutability: true, strictActionImmutability: true },
            }),
            UserModule.forRoot(),
            !environment.production
                ? StoreDevtoolsModule.instrument({
                      name: 'Gaia',
                      maxAge: 100,
                      connectInZone: true,
                  })
                : [],
            EffectsModule.forRoot([RouterEffects]),
            HttpClientModule,
            CoreModule.forRoot(),
            AuthModule.forRoot(),
            EventsModule,
            AppRouterModule,
            MatSnackBarModule
        ),
        { provide: APP_BASE_HREF, useValue: '/' },
    ],
};
